import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import NotFound from "../notfound/NotFound";

export const CustomAutocomplete = ({
  options,
  value,
  onChange,
  isLoading,
  placeholder,
}) => (
  <Autocomplete
    options={options || []}
    getOptionLabel={(option) => option.name}
    value={value}
    onChange={onChange}
    noOptionsText={<NotFound />}
    isOptionEqualToValue={(option, value) => option.id === value?.id}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder={isLoading ? "در حال بارگذاری ..." : placeholder}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
        inputProps={{
          ...params.inputProps,
          style: { textAlign: "right" },
        }}
      />
    )}
  />
);
